import script from "./Paginator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Paginator.vue?vue&type=script&setup=true&lang=ts"

import "./Paginator.vue?vue&type=style&index=0&id=e8dfca1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8dfca1e"]])

export default __exports__